import styled from "styled-components";


export const Card = styled.div`
  background: var(--color-gray-100);
  border-radius: 20px;
  border: ${props => props.highlight ? '2px solid var(--color-purple)' : '1px solid #d2d1d4'};
  overflow: hidden;
  box-shadow: none;
  transition: box-shadow 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: ${props => !props.isCurrent ? 'pointer' : 'unset' };
  width: 100%;
  margin: 0 auto;
  height: ${props => props.height ?? '430px'};
  max-width: calc(100vw - 48px);

  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  @media (max-width: 1104px) {
    height: auto;
  }
`;

export const CardHeader = styled.div`
  width: 100%;
  height: 210px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CardImage = styled.img`
  width: 100%;
  height: 210px;
  object-fit: cover;
  transition: transform 0.3s;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;

  ${Card}:hover & {
    transform: scale(1.05);
  }
`;

export const CardContent = styled.div`
  padding: 32px 28px 28px 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CardDate = styled.span`
  color: var(--color-gray-500);
  font-size: var(--text-size-xs);
  font-weight: 400;
`;

export const CardTitle = styled.h2`
  color: var(--color-gray-600);
  font-size: ${props => props.height === 'auto' ? 'var(--text-size-lg)' : 'var(--text-size-sm)' };
  font-weight: 700;
  margin: 0;
  &:hover { color: var(--color-purple); }
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: ${props => props.height === 'auto' ? 'unset' : '1' };
  -webkit-box-orient: ${props => props.height === 'auto' ? 'unset' : 'vertical'};
  text-overflow: ${props => props.height === 'auto' ? 'unset' : 'ellipsis'};
  text-transform: none;

  @media (max-width: 1104px) {
    -webkit-line-clamp: unset;
    -webkit-box-orient: unset;
    text-overflow: unset;
    font-size: var(--text-size-xs);
  }
`;

export const CardDescription = styled.p`
  color: #8c8c8c;
  font-size: var(--text-size-xs);
  font-weight: 400;
  margin: 0;
  line-height: 1.5rem;
  display:  ${props => !props.isCurrent ? '-webkit-box' : 'unset' };
  overflow: hidden;
  -webkit-line-clamp: ${props => props.height === 'auto' ? 'unset' : '3' };
  -webkit-box-orient: ${props => props.height === 'auto' ? 'unset' : 'vertical'};
  text-overflow: ${props => props.height === 'auto' ? 'unset' : 'ellipsis'};
  white-space: ${props => props.height === 'auto' ? 'break-spaces' : 'unset'};
  text-transform: none;
  & p {
    margin: 0 0 10px;
  }
  & ul, & ol {
    margin: 0 0 10px 20px;
    padding-left: 20px;
  }
  & ul {
    list-style: disc;
  }
  & ol {
    list-style: decimal;
  }
  & li {
    margin-bottom: 4px;
    list-style: unset;
  }
  & *, & *:not([style*="color"]) {
    color: #8c8c8c !important;
    text-transform: none;
  }
`;